import * as yup from "yup";

export const applicantloginrule = yup.object({
  emailaddress: yup
    .string()
    .email("Invalid email address given")
    .required("Valid email address is required"),
  password: yup
    .string()
    .min(8, "Minimum of 8 characters expected")
    .max(32, "Maximum of 32 characters expected")
    .required("Password is a required field"),
});

export const forgetpasswordrules = yup.object({
  emailaddress: yup
    .string()
    .email("Invalid email address")
    .required("Valid email address is required"),
});

export const createapplicantrules = yup.object({
  firstname: yup.string().required("First name is a required field"),
  lastname: yup.string().required("Last name is a required field"),
  emailaddress: yup
    .string()
    .email("Invalid email address")
    .required("Valid email address is required"),
  jamb: yup.string().required("JAMB Admission number is a required field"),
  phonenumber: yup
    .string()
    .min(13, "Format not followed (23480xxxxxxxx)")
    .max(13, "Format not followed (23480xxxxxxxx)")
    .required("Phone number is a required field"),
  password: yup
    .string()
    .min(8, "Minimum of 8 characters expected")
    .max(32, "Maximum of 32 characters expected")
    .required("Password is a required field"),
  confirmpassword: yup
    .string()
    .oneOf([yup.ref("password"), null], "Passwords must match"),
});

export const update = yup.object({
  firstname: yup.string().required("First name is a required field"),
  lastname: yup.string().required("Last name is a required field"),
  emailaddress: yup
    .string()
    .email("Invalid email address")
    .required("Valid email address is required"),
  jamb: yup.string().required("JAMB Admission number is a required field"),
  phonenumber: yup
    .string()
    .min(13, "Format not followed (23480xxxxxxxx)")
    .max(13, "Format not followed (23480xxxxxxxx)")
    .required("Phone number is a required field"),
});

const ms_applicant = {
  applicantloginrule,
  createapplicantrules,
  forgetpasswordrules,
  update,
};

export default ms_applicant;
